import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminDriverRequest = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Drivers Request</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row p-2">
                      <div className="col">
                        <form action="">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Drivers "
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Cover</th>
                            <th>Name</th>
                            <th>City</th>
                            <th>Address</th>
                            <th>Gender</th>
                            <th>Mobile</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>MILONI LODKE</td>
                            <td>Bhavnagar</td>
                            <td>Near Havamahel Motor Garage Palitana</td>
                            <td>Male</td>
                            <td>+912312526341</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Accept
                              </a>
                              <button className="btn btn-danger btn-sm">
                                Reject
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminDriverRequest;
